module.exports = __webpack_public_path__ + "static/3_icon-1df7b892d1330d46e18d0e153dd612be.svg";